import * as React from "react"
import { connect } from "react-redux"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { FieldItems, Input } from "@tenforce/toolbox-field-react"

import { bem } from "../../../bem"
import { DispatchProps, mapDispatchToProps } from "../actions"
import { GlobalState } from "../../../store"
import { Symbols } from "@tenforce/toolbox-fontmap"

import "./SimpleSearchField.scss"
import { Labels } from "../../../util/Translations"
import { ISearch } from "../index"

const b = bem.with("NewUI__simpleSearchField")

interface OwnProps {
    autoFocus: boolean
    background: "dark" | "transparent"
    inputColor: "white" | "transparent"
    showButtonsOnlyIfFocus: boolean
}

type StateProps = ISearch

type Props = OwnProps & StateProps & DispatchProps

interface State {
    hasFocus: boolean
    hasHover: boolean
    searchInputValue: string
}

export class SimpleSearchField extends React.Component<Props, State> {
    static defaultProps: Partial<Props> = {
        autoFocus: true,
        background: "dark",
        inputColor: "transparent",
        showButtonsOnlyIfFocus: false,
    }

    constructor(props: Props) {
        super(props)
        this.state = {
            hasFocus: props.autoFocus,
            hasHover: false,
            searchInputValue: "",
        }
    }

    render(): JSX.Element {
        const {
            autoFocus,
            background,
            workspaceId,
            inputColor,
            showButtonsOnlyIfFocus,
        } = this.props
        const { hasFocus, hasHover, searchInputValue } = this.state

        const { SearchInAllWorkspaces, SearchInThisWorkspace } = Labels

        const placeholder =
            workspaceId === 0 ? SearchInAllWorkspaces : SearchInThisWorkspace
        const showButtons = !showButtonsOnlyIfFocus || hasFocus || hasHover

        return (
            <FieldItems
                onMouseEnter={(): void => this.setHover(true)}
                onMouseLeave={(): void => this.setHover(false)}
                isInverted={background === "dark"}
                hasWhiteBackground={inputColor === "white"}
                extraClasses={`${b()} tw-p-2 ${
                    background === "dark" ? "bg-darkest" : ""
                }`}
            >
                <Input
                    autoFocus={autoFocus}
                    type="search"
                    placeholder={placeholder}
                    value={searchInputValue}
                    onBlur={(): void => this.setFocus(false)}
                    onChangedValue={(searchInputValue): void =>
                        this.setState({ searchInputValue })
                    }
                    onFocus={(): void => this.setFocus(true)}
                    onKeyUp={this.handleKeyUp}
                    data-ft-search-input
                />
                <Action
                    actionType={ActionType.icon}
                    onClick={this.doSearch}
                    data-ft-search-button
                    extraClasses={`${!showButtons ? "is-hidden-action" : ""}`}
                >
                    {Symbols.Search}
                </Action>
            </FieldItems>
        )
    }

    handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === "Enter") {
            this.doSearch()
        }
    }

    doSearch = (): void => {
        const { searchInputValue } = this.state
        const { requestSearch } = this.props
        this.setState({ searchInputValue: "" })
        requestSearch(searchInputValue)
    }

    setFocus = (hasFocus: boolean): void => {
        this.setState({ hasFocus })
    }

    setHover = (hasHover: boolean): void => {
        this.setState({ hasHover })
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.search

export default connect(mapStateToProps, mapDispatchToProps)(SimpleSearchField)
